import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";
import { UserProvider, UserConsumer } from "./Contexts/user";
import Login from "./Pages/Login";
import Layout from "./Components/layout";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "@apollo/react-hooks";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import Download from "./Pages/Download";
import Routes from "./Routes";
import { PDFViewer } from "@react-pdf/renderer";
import { SidebarProvider } from "./Contexts/sidebar";
import EditCase from "./Pages/EditCase";
import { storage } from "./helpers/storage";

let BASE_URL = undefined;
if (process.env.NODE_ENV === "production") {
    BASE_URL="https://api.nfctrackings.com";

    var httpLink = createHttpLink({
        uri: BASE_URL,
    });
} else if (process.env.NODE_ENV === "development") {
    var developmentLink = createHttpLink({
        uri: "http://localhost:5000",
    });
}


const authLink = setContext((_, { headers }) => {
    const authObj = storage.get("auth");

    return {
        headers: {
            ...headers,
            authorization: authObj ? `Bearer ${authObj.token}` : "",
        },
    };
});

const client = new ApolloClient({
    link: httpLink
        ? authLink.concat(httpLink)
        : authLink.concat(developmentLink),
    cache: new InMemoryCache(),
});

export default () => {
    return (
        <SidebarProvider>
            <ApolloProvider client={client}>
                <UserProvider>
                    <UserConsumer>
                        {(user) => {
                            const AuthRoute = ({
                                component: Component,
                                ...rest
                            }) => {
                                return (
                                    <Route
                                        {...rest}
                                        render={(props) =>
                                            !user.auth.token ? (
                                                <Component {...props} />
                                            ) : (
                                                <Redirect
                                                    to={{
                                                        pathname: "/cases",
                                                        state: {
                                                            from: props.location,
                                                        },
                                                    }}
                                                />
                                            )
                                        }
                                    />
                                );
                            };

                            const PrivateRoute = ({
                                component: Component,
                                ...rest
                            }) => {
                                return (
                                    <Route
                                        {...rest}
                                        render={(props) =>
                                            user.auth.token ? (
                                                <Component {...props} />
                                            ) : (
                                                <Redirect
                                                    to={{
                                                        pathname: "/login",
                                                        state: {
                                                            from: props.location,
                                                        },
                                                    }}
                                                />
                                            )
                                        }
                                    />
                                );
                            };

                            return (
                                <Router>
                                    {user.auth.loaded && (
                                        <Switch>
                                            <AuthRoute
                                                path="/login"
                                                component={Login}
                                                exact
                                            />
                                            <Route path="/download" exact>
                                                {({ location }) => {
                                                    return (
                                                        <div className="report-container">
                                                            <PDFViewer>
                                                                <Download
                                                                    data={
                                                                        location.state
                                                                    }
                                                                />
                                                            </PDFViewer>
                                                        </div>
                                                    );
                                                }}
                                            </Route>
                                            <Layout>
                                                <PrivateRoute path="/cases/edit/:id" component={EditCase} />
                                                {Routes.map((route, i) => (
                                                    <PrivateRoute
                                                        exact
                                                        path={route.path}
                                                        component={route.component}
                                                        key={route.name}
                                                    />
                                                ))}
                                                <Route exact path="/">
                                                    <Redirect to="/cases" />
                                                </Route>
                                            </Layout>
                                            <Redirect to="/cases" />
                                        </Switch>
                                    )}
                                </Router>
                            );
                        }}
                    </UserConsumer>
                </UserProvider>
            </ApolloProvider>
        </SidebarProvider>
    );
};
